import classnames from "classnames";
import React, { ReactNode } from "react";
import { Hyperlink } from "src/components";
import { bannerHomeOnClickTracking } from "src/services/analytics.service";
import styled from "styled-components";

import { IBanner, ITemplateName, ITemplateType } from "../../types";

import RenderContent from "./RenderContent";

interface IWrapper {
  template?: string;
}

const BannersWrapper = styled.div<IWrapper>`
  display: flex;
  flex-direction: column;
`;

interface IBannerWrapper {
  background?: string;
}
const BannerWrapper = styled.div<IBannerWrapper>`
  background-color: ${({ background }: IBannerWrapper): string | undefined =>
    background};

  &.banner-background > a {
    display: inline-block;
    height: 100%;
  }
`;

// Analytocs: track click on banner
const homeBannerTracking = (bannerBlockIndex: number, index: number): void => {
  const bannerName = `banner_mobile_block${bannerBlockIndex + 1}_banner${
    index + 1
  }`;
  bannerHomeOnClickTracking(bannerName);
};

interface IProps {
  children?: ReactNode;
  className?: string;
  bannersBlock: IBanner[];
  templateType: ITemplateType;
  templateName?: ITemplateName;
  pageType: string;
  bannerBlockIndex: 1 | 0;
  brandId?: string;
}

const BannersElement = ({
  children,
  className,
  bannersBlock,
  templateType,
  templateName,
  pageType,
  bannerBlockIndex,
  brandId,
}: IProps): JSX.Element => {
  if (templateType === "background") {
    bannersBlock = [
      bannersBlock.filter((item) => item["background_on_" + pageType])[0],
    ];
  }

  return (
    <BannersWrapper
      className={classnames(
        "banner-wrapper",
        `banner-wrapper-${pageType}`,
        templateType && `banner-wrapper-${templateType}`,
        className
      )}
      template={templateType}
    >
      {bannersBlock.map((banner: IBanner, index: number): ReactNode | null => {
        if (!banner) {
          return children ? <>{children}</> : null;
        }

        // Hyperlink around a banner
        return (
          <BannerWrapper
            key={`BannerBlock-${index}`}
            background={banner.background_color}
            className={`banner banner-${templateType}${
              templateName ? "-" + templateName : ""
            }`}
          >
            {templateType === "background" ? (
              <RenderContent
                templateType={templateType}
                banner={banner}
                pageType={pageType}
                brandId={brandId}
              >
                {children}
              </RenderContent>
            ) : (
              <Hyperlink
                to={banner.banner_redirect}
                onClick={(): void | null =>
                  templateType === "homepage"
                    ? homeBannerTracking(bannerBlockIndex, index)
                    : null
                }
              >
                <RenderContent
                  templateType={templateType}
                  banner={banner}
                  pageType={pageType}
                  brandId={brandId}
                >
                  {children}
                </RenderContent>
              </Hyperlink>
            )}
          </BannerWrapper>
        );
      })}
    </BannersWrapper>
  );
};

export default BannersElement;
